import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import VerificaToken from "./VerificaToken";

function RimozionePatente() {
  const { user, setUser } = VerificaToken();
  const [show, setShow] = useState(false);
  let history = useHistory();

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const elimina = () => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/rimuoviPatente`
      )
      .then((response) => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setShow(false);
            setUser(res.data);
            history.go(0);
          });
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  };
  if (user.codicePatente) {
    return (
      <>
        <Link onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-card-text"
            viewBox="0 0 16 16"
          >
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
          </svg>
          <h3>Rimuovi Patente</h3>
          <p>Clicca qui per rimuovere la patente inserita precedentemente.</p>
        </Link>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Rimozione Patente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di volere rimuovere la tua patente?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Torna Indietro
            </Button>
            <Button variant="primary" onClick={elimina}>
              Sono Sicuro
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return (
      <>
        <Link onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-card-text"
            viewBox="0 0 16 16"
          >
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
          </svg>
          <h3>Rimuovi Patente</h3>
          <p>Clicca qui per rimuovere la patente inserita precedentemente.</p>
        </Link>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Rimozione Patente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Non hai inserito alcuna patente, vuoi inserine una ora?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No grazie.
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                history.push(`/account/info/${user.id}/aggiungiPatente`);
              }}
            >
              Va bene!
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default RimozionePatente;
